var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { showApplicationLoader, hideApplicationLoader, } from 'common/ApplicationLoader';
import { emptyStringToNull, getCurrentSenior } from 'globals/global.functions';
import { API } from 'globals/api';
import { getDevicesService, getDevicesServiceExtra } from 'services/deviceService/device.service';
import { openOverlayDialog, showError } from 'store/commonReducer/common.action';
import { DEVICE_TYPE, DIALOG_TYPES } from 'globals/global.constants';
export var GET_DEVICES_DATA = 'GET_DEVICES_DATA';
export var GET_DEVICES_DATA_SUCCESSFUL = 'GET_DEVICES_DATA_SUCCESSFUL';
export var GET_DEVICES_DATA_FAIL = 'GET_DEVICES_DATA_FAIL';
export var GET_WATCH_DETAILS = 'GET_WATCH_DETAILS';
export var RESET_WATCH_DETAILS = 'RESET_WATCH_DETAILS';
export var getDevicesInfo = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var seniorInfo, param, res, syncParams, extraRes_1, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                seniorInfo = getCurrentSenior();
                if (!seniorInfo.senior_id && !seniorInfo.account_id) {
                    return [2 /*return*/];
                }
                param = {
                    senior_id: seniorInfo.senior_id,
                    account_id: seniorInfo.account_id,
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                // dispatch(showApplicationLoader());
                dispatch({
                    type: GET_DEVICES_DATA,
                });
                return [4 /*yield*/, getDevicesService(param)];
            case 2:
                res = _a.sent();
                syncParams = { senior_id: seniorInfo.senior_id };
                return [4 /*yield*/, getDevicesServiceExtra(syncParams)];
            case 3:
                extraRes_1 = _a.sent();
                res = res.map(function (device) {
                    var senior = extraRes_1[device.senior_id];
                    if (!senior)
                        return device;
                    var syncData = senior[device.device_type];
                    if (!syncData)
                        return device;
                    return __assign(__assign({}, device), { last_ingestion_date: syncData.last_ingestion_date, last_session_date: syncData.last_session_date });
                });
                dispatch(hideApplicationLoader());
                dispatch({
                    type: GET_DEVICES_DATA_SUCCESSFUL,
                    payload: {
                        data: res,
                    },
                });
                return [3 /*break*/, 5];
            case 4:
                err_1 = _a.sent();
                dispatch({
                    type: GET_DEVICES_DATA_FAIL,
                });
                dispatch(hideApplicationLoader());
                dispatch(showError(err_1));
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
export var getDevicesInfoCWMemeberRecords = function (param) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var res, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch(showApplicationLoader());
                return [4 /*yield*/, getDevicesService(param)];
            case 1:
                res = _a.sent();
                dispatch(hideApplicationLoader());
                return [2 /*return*/, res || []];
            case 2:
                err_2 = _a.sent();
                dispatch({
                    type: GET_DEVICES_DATA_FAIL,
                });
                dispatch(hideApplicationLoader());
                dispatch(showError(err_2));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var saveDevicesDetail = function (data, height, weight, timezone, type) {
    return function (dispatch) {
        dispatch(showApplicationLoader());
        var accountInfo = getCurrentSenior();
        data = emptyStringToNull(data);
        var apiData = __assign(__assign({}, data), { senior_id: accountInfo.senior_id, timezone: timezone, weight: weight, height: height });
        return API({
            url: 'users/medical-device',
            method: 'put',
            data: apiData,
        })
            .then(function () {
            var _a;
            if (type === 'watch' && ((_a = data === null || data === void 0 ? void 0 : data.vendor) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'navigil') {
                dispatch(connectNavigilDevice(data.device_serial));
            }
            else {
                dispatch(hideApplicationLoader());
                dispatch(openOverlayDialog({
                    type: DIALOG_TYPES.SUCCESS,
                    // eslint-disable-next-line max-len
                    firstMessage: "Device has been saved successfully.",
                }));
                dispatch(getDevicesInfo());
            }
            return { success: true };
        })
            .catch(function (err) {
            var _a, _b, _c, _d, _e;
            dispatch(hideApplicationLoader());
            var errorMessage = err.response.data.message;
            var RADIUS_CONSTRAINT_ERROR = 'Medical Device is in violation of the following constraint: Please set the radius before linking the watch.';
            if (errorMessage ===
                'This device is currently assigned to another user' ||
                errorMessage === RADIUS_CONSTRAINT_ERROR) {
                if (errorMessage === RADIUS_CONSTRAINT_ERROR)
                    errorMessage = 'Please set the radius before linking the watch.';
                dispatch(openOverlayDialog({
                    type: DIALOG_TYPES.ERROR2,
                    // eslint-disable-next-line max-len
                    firstMessage: errorMessage,
                }));
                return;
            }
            if (err.response.data.message !==
                'Medical Device is in violation of the following constraint: Please Enter Valid IMEI Number') {
                dispatch(showError(err));
            }
            // Extract error details to make them easier to use in the component
            var errorDetails = {
                message: ((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || err.message || 'Unknown error occurred',
                code: ((_d = (_c = err.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.application_code) || err.code,
                status: (_e = err.response) === null || _e === void 0 ? void 0 : _e.status,
                originalError: err
            };
            return Promise.reject(errorDetails);
        });
    };
};
export var deleteDevicesDetail = function (data, deviceName) {
    return function (dispatch) {
        var accountInfo = getCurrentSenior();
        var apiData = __assign(__assign({}, data), { senior_id: accountInfo.senior_id });
        dispatch(showApplicationLoader());
        API({
            url: 'users/medical-device',
            method: 'delete',
            data: apiData,
        })
            .then(function () {
            dispatch(hideApplicationLoader());
            dispatch(openOverlayDialog({
                type: DIALOG_TYPES.SUCCESS,
                // eslint-disable-next-line max-len
                firstMessage: "Device has been deleted successfully.",
            }));
            dispatch({
                type: RESET_WATCH_DETAILS,
            });
            dispatch(getDevicesInfo());
            return { success: true };
        })
            .catch(function (err) {
            dispatch(hideApplicationLoader());
            dispatch(showError(err));
        });
    };
};
export var connectNavigilDevice = function (serialId) {
    return function (dispatch) {
        var accountInfo = getCurrentSenior();
        var apiData = {
            serial_id: serialId,
            device_type: DEVICE_TYPE.WATCH,
            account_id: accountInfo.account_id,
            senior_id: accountInfo.senior_id,
        };
        return API({
            url: 'users/vendor/navigil-registration',
            method: 'post',
            data: apiData,
        })
            .then(function () {
            dispatch(hideApplicationLoader());
            dispatch(openOverlayDialog({
                type: DIALOG_TYPES.SUCCESS,
                firstMessage: "Device has been saved successfully.",
            }));
            dispatch(getDevicesInfo());
            return { success: true };
        })
            .catch(function (err) {
            dispatch(hideApplicationLoader());
            if (err.response.data.message === 'Conflict - device reset running.') {
                dispatch(openOverlayDialog({
                    type: DIALOG_TYPES.ERROR2,
                    firstMessage: "This watch is currently resetting.",
                    secondMessage: "Please wait for the reset to complete before assigning it again.",
                }));
                return;
            }
            dispatch(showError(err));
        });
    };
};
export var updateDevicesDetail = function (data) {
    return function (dispatch) {
        dispatch(showApplicationLoader());
        var accountInfo = getCurrentSenior();
        data = emptyStringToNull(data);
        var apiData = {
            senior_id: accountInfo.senior_id,
            device_id: data.device_id,
            device_serial: data.device_serial,
            vendor: data.vendor,
            sensitivity_data: data.sensitivity_data,
            install_date: data.install_date,
        };
        return API({
            url: 'users/medical-device',
            method: 'patch',
            data: apiData,
        })
            .then(function () {
            dispatch(hideApplicationLoader());
            dispatch(openOverlayDialog({
                type: DIALOG_TYPES.SUCCESS,
                firstMessage: "Device sensitivity has been updated successfully.",
            }));
            dispatch(getDevicesInfo());
            return { success: true };
        })
            .catch(function (err) {
            var _a, _b, _c, _d, _e, _f, _g;
            dispatch(hideApplicationLoader());
            var errorMessage = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
            if (errorMessage === 'This device is currently assigned to another user') {
                dispatch(openOverlayDialog({
                    type: DIALOG_TYPES.ERROR2,
                    firstMessage: errorMessage,
                }));
                return;
            }
            if (errorMessage !==
                'Medical Device is in violation of the following constraint: Please Enter Valid IMEI Number') {
                dispatch(showError(err));
            }
            var errorDetails = {
                message: ((_d = (_c = err.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) || err.message || 'Unknown error occurred',
                code: ((_f = (_e = err.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.application_code) || err.code,
                status: (_g = err.response) === null || _g === void 0 ? void 0 : _g.status,
                originalError: err,
            };
            return Promise.reject(errorDetails);
        });
    };
};
